<template>
  <div class="w-8 h-8 rounded-full bg-sky-lightest flex items-center justify-center text-base font-medium text-gray-darker shrink-0">
    {{ step }}
  </div>
</template>

<script setup>
defineProps({
  step: {
    type: Number,
    required: true,
  },
})
</script>
